import { ITextInputProps } from "@model/UIComponents.model";
import React from "react";
import styles from './UiLibraryComponent.module.css'


const TextInput: React.FC<ITextInputProps> = ({
  label,
  placeholder,
  type = "text",
  error,
  value,
  onChange,
  disabled = false,
  customClassName = "",
  onBlur
}) => {
  return (
    <div className={styles.inputContainer }>
      <label
        className={styles.inputLabel}
        data-testid="custom_text_input_label"
      >
        {label}
      </label>
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        className={`${styles.textInput} ${customClassName} ${
          error ? styles.inputWithError : ""
        } ${disabled ? styles.disabledInput : ""}`}
        data-testid="custom_text_input_field"
        onBlur={onBlur}
      />


      {error && (
        <div
          data-testid="custom_text_input_error"
          className={styles.errorMessage}
        >
          {error}
        </div>
      )}
    </div>
  );
};





export default TextInput;